import { Outlet, useParams } from "react-router-dom";
import Header from "@/components/Header";

export default function ChatLayout() {

  return (
    <div className="flex flex-col h-screen">
      <Header name="Messages" shouldGoBack />
      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}